import React from 'react'
import { FacetSelect } from '../BaseComponents/FacetSelect'

const FacetGroup = () => (
  <FacetSelect facetCategory="group" source="groupFacet" />
)

export default FacetGroup
